const STICKY_ATC_STYLE_ID = 'sticky-atc-conversion-styles';
const STICKY_ATC_UPDATE_EVENTS = ['variant:updated', 'quantity-breaks:updated', 'form:updated'];

if (!document.getElementById(STICKY_ATC_STYLE_ID)) {
  const style = document.createElement('style');
  style.id = STICKY_ATC_STYLE_ID;
  style.textContent = `
    :root {
      --z-index-sticky-atc: 20;
    }

    .sticky-atc__inner {
      width: 100%;
    }

    .sticky-atc__context {
      display: none;
      min-width: 0;
    }

    .sticky-atc__media {
      flex: 0 0 56px;
      width: 56px;
      height: 56px;
      overflow: hidden;
      border-radius: 8px;
      background: color-mix(in srgb, var(--color-foreground) 5%, transparent);
    }

    .sticky-atc__image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .sticky-add-to-cart[data-active="true"] .sticky-add-to-cart__content,
    .sticky-add-to-cart[data-closing="true"] .sticky-add-to-cart__content {
      z-index: var(--z-index-sticky-atc);
      padding: 12px var(--page-margin-desktop);
      background: var(--color-background);
      animation-duration: 240ms;
      animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
    }

    .sticky-add-to-cart[data-active="true"] .sticky-atc__inner,
    .sticky-add-to-cart[data-closing="true"] .sticky-atc__inner {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(320px, 360px);
      align-items: center;
      gap: clamp(24px, 4vw, 64px);
      width: 100%;
      max-width: var(--page-width);
      margin: 0 auto;
    }

    .sticky-add-to-cart[data-active="true"] .sticky-atc__context,
    .sticky-add-to-cart[data-closing="true"] .sticky-atc__context {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .sticky-add-to-cart[data-active="true"] .product-add-to-cart-button,
    .sticky-add-to-cart[data-closing="true"] .product-add-to-cart-button {
      width: 100%;
      max-width: 360px;
      margin: 0;
    }

    .sticky-atc__details {
      display: flex;
      flex-direction: column;
      gap: 3px;
      min-width: 0;
    }

    .sticky-atc__title {
      overflow: hidden;
      margin: 0;
      color: var(--color-foreground);
      font-size: 14px;
      font-weight: 600;
      line-height: 1.25;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .sticky-atc__edit {
      display: flex;
      align-items: center;
      gap: 8px;
      width: fit-content;
      max-width: 100%;
      min-height: 24px;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: var(--color-foreground);
      font: inherit;
      cursor: pointer;
    }

    .sticky-atc__configuration {
      overflow: hidden;
      font-size: 13px;
      line-height: 1.35;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .sticky-atc__discount {
      flex: none;
      padding: 2px 7px;
      border-radius: 999px;
      background: color-mix(in srgb, var(--color-foreground) 9%, transparent);
      font-size: 11px;
      font-weight: 700;
      line-height: 1.35;
    }

    .sticky-atc__edit-label {
      flex: none;
      font-size: 12px;
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    .sticky-atc__edit:focus-visible {
      outline: 2px solid var(--color-foreground);
      outline-offset: 4px;
    }

    .sticky-atc__live {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    @media (max-width: 750px) {
      .sticky-add-to-cart[data-active="true"] .sticky-add-to-cart__content,
      .sticky-add-to-cart[data-closing="true"] .sticky-add-to-cart__content {
        padding:
          8px
          var(--page-margin-mobile)
          max(8px, env(safe-area-inset-bottom));
      }

      .sticky-add-to-cart[data-active="true"] .sticky-atc__inner,
      .sticky-add-to-cart[data-closing="true"] .sticky-atc__inner {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 7px;
      }

      .sticky-add-to-cart[data-active="true"] .product-add-to-cart-button,
      .sticky-add-to-cart[data-closing="true"] .product-add-to-cart-button {
        max-width: none;
      }

      .sticky-atc__details {
        width: 100%;
      }

      .sticky-atc__media {
        flex-basis: 42px;
        width: 42px;
        height: 42px;
        border-radius: 6px;
      }

      .sticky-atc__title {
        display: none;
      }

      .sticky-atc__edit {
        width: 100%;
      }

      .sticky-atc__configuration {
        flex: 1;
        text-align: left;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .sticky-add-to-cart[data-active="true"] .sticky-add-to-cart__content,
      .sticky-add-to-cart[data-closing="true"] .sticky-add-to-cart__content {
        animation: none;
      }
    }
  `;
  document.head.appendChild(style);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.inner = null;
    this.context = null;
    this.imageElement = null;
    this.titleElement = null;
    this.configurationElement = null;
    this.discountElement = null;
    this.editLabelElement = null;
    this.liveElement = null;
    this.formInView = true;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
    this.resizeObserver = null;
    this.updateFrame = null;
    this.closeTimer = null;

    this.handleChoiceChange = this.handleChoiceChange.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;

    this.#buildContext();
    this.#observeChoices();

    requestAnimationFrame(() => {
      this.#reserveStaticHeight();
      this.#initObservers();
      this.#updateSummary();
    });
  }

  disconnectedCallback() {
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.resizeObserver?.disconnect();
    this.form?.removeEventListener('change', this.handleChoiceChange);
    STICKY_ATC_UPDATE_EVENTS.forEach((eventName) => {
      this.form?.removeEventListener(eventName, this.handleChoiceChange);
    });
    this.context?.removeEventListener('click', this.handleEdit);

    if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    if (this.closeTimer) clearTimeout(this.closeTimer);
  }

  handleChoiceChange() {
    this.#scheduleSummaryUpdate();
  }

  handleEdit() {
    const preferredOption =
      this.form.querySelector('input[name*="Taille"]:checked') ||
      this.form.querySelector('input[name*="Size"]:checked') ||
      this.form.querySelector('input[name^="option-"]:checked');

    const target =
      preferredOption?.closest('fieldset, .variant-option, [data-option-name]') ||
      preferredOption ||
      this.form;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    requestAnimationFrame(() => preferredOption?.focus({ preventScroll: true }));
  }

  #buildContext() {
    this.inner = document.createElement('div');
    this.inner.className = 'sticky-atc__inner';

    while (this.content.firstChild) this.inner.appendChild(this.content.firstChild);

    this.context = document.createElement('div');
    this.context.className = 'sticky-atc__context';

    const media = document.createElement('div');
    media.className = 'sticky-atc__media';

    this.imageElement = document.createElement('img');
    this.imageElement.className = 'sticky-atc__image';
    this.imageElement.width = 112;
    this.imageElement.height = 112;
    this.imageElement.decoding = 'async';
    this.imageElement.alt = '';
    media.append(this.imageElement);

    const details = document.createElement('div');
    details.className = 'sticky-atc__details';

    this.titleElement = document.createElement('p');
    this.titleElement.className = 'sticky-atc__title';

    const editButton = document.createElement('button');
    editButton.type = 'button';
    editButton.className = 'sticky-atc__edit';

    this.configurationElement = document.createElement('span');
    this.configurationElement.className = 'sticky-atc__configuration';

    this.discountElement = document.createElement('span');
    this.discountElement.className = 'sticky-atc__discount';
    this.discountElement.hidden = true;

    this.editLabelElement = document.createElement('span');
    this.editLabelElement.className = 'sticky-atc__edit-label';

    editButton.append(this.configurationElement, this.discountElement, this.editLabelElement);
    details.append(this.titleElement, editButton);
    this.context.append(media, details);

    this.liveElement = document.createElement('span');
    this.liveElement.className = 'sticky-atc__live';
    this.liveElement.setAttribute('aria-live', 'polite');
    this.liveElement.setAttribute('aria-atomic', 'true');

    const addToCartContainer = this.inner.querySelector('.product-add-to-cart-button');
    this.inner.insertBefore(this.context, addToCartContainer);
    this.inner.append(this.liveElement);
    this.content.append(this.inner);
    this.context.addEventListener('click', this.handleEdit);
  }

  #observeChoices() {
    this.form.addEventListener('change', this.handleChoiceChange);
    STICKY_ATC_UPDATE_EVENTS.forEach((eventName) => {
      this.form.addEventListener(eventName, this.handleChoiceChange);
    });

    this.resizeObserver = new ResizeObserver(() => {
      if (this.dataset.active !== 'true' && !this.dataset.closing) this.#reserveStaticHeight();
    });
    this.resizeObserver.observe(this.content);
  }

  #scheduleSummaryUpdate() {
    if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => {
      this.#updateSummary();
      this.updateFrame = null;
    });
  }

  #updateSummary() {
    const language = document.documentElement.lang || 'fr';
    const isFrench = language.toLowerCase().startsWith('fr');
    const selectedOptions = Array.from(this.form.querySelectorAll('input[name^="option-"]:checked'));
    const quantityBreak = this.form.querySelector('[data-ref="quantity-break-item"].quantity-break--selected');
    const quantityInput = this.form.querySelector('[data-ref="quantity-selector-input"], [data-ref="product-quantity-selector"] input[name="quantity"]');
    const quantity = Number(quantityBreak?.dataset.quantity || quantityInput?.value || 1);
    const quantityLabel = `${quantity} ${this.dataset.itemLabel || 'Stück'}`;
    const configuration = [...selectedOptions.map(option => option.value), quantityLabel].filter(Boolean).join(' · ');
    const totalPrice = Number(quantityBreak?.dataset.totalPrice || 0);
    const compareAtPrice = Number(quantityBreak?.dataset.totalCompareAtPrice || 0);
    const discount = compareAtPrice > totalPrice
      ? Math.round(((compareAtPrice - totalPrice) / compareAtPrice) * 100)
      : 0;
    const productHeading = Array.from(document.querySelectorAll('h1')).find(
      (heading) => heading.getClientRects().length > 0 && !heading.closest('dialog, [aria-hidden="true"]'),
    );
    const productTitle = productHeading?.textContent?.trim() || document.title.split('–')[0].trim();

    this.titleElement.textContent = productTitle;
    this.#updateImage(productTitle, quantityBreak);
    this.configurationElement.textContent = configuration || productTitle;
    this.editLabelElement.textContent = this.dataset.editLabel || 'Ändern';
    this.discountElement.textContent = discount ? `−${discount} %` : '';
    this.discountElement.hidden = !discount;

    const editButton = this.context.querySelector('.sticky-atc__edit');
    editButton.setAttribute(
      'aria-label',
      `${this.dataset.editLabel || 'Ändern'}: ${configuration || productTitle}`,
    );
    const announcement = discount
      ? `${configuration}, ${isFrench ? 'économie' : 'save'} ${discount} %`
      : configuration;
    if (this.liveElement.textContent !== announcement) this.liveElement.textContent = announcement;
  }

  #formatSize(value) {
    if (!value) return '';
    const formatted = value.replace(/\s*[xX]\s*/g, ' × ').replace(/\s+/g, ' ').trim();
    return /\d/.test(formatted) && !/\bcm\b/i.test(formatted) ? `${formatted} cm` : formatted;
  }

  #updateImage(productTitle, quantityBreak) {
    const selectedVariantOption = quantityBreak?.querySelector(
      '[data-ref="quantity-break-variant-picker"] option:checked',
    );
    const galleryImage = document.querySelector('product-media-gallery .product-media img');
    const source = selectedVariantOption?.dataset.variantImage || galleryImage?.currentSrc || galleryImage?.src;
    if (!source || !this.imageElement) return;

    const thumbnail = this.#thumbnailUrl(source);
    if (this.imageElement.src !== thumbnail) this.imageElement.src = thumbnail;
    this.imageElement.alt = selectedVariantOption?.dataset.variantImageAlt || productTitle;
  }

  #thumbnailUrl(source) {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '160');
      return url.href;
    } catch {
      return source;
    }
  }

  #formatFixation(value) {
    if (!value) return '';
    return value
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/multi-fonction/i, 'Multifonction')
      .replace(/plis flamands/i, 'Plis flamands')
      .trim();
  }

  #reserveStaticHeight() {
    const staticHeight = this.content.offsetHeight;
    if (staticHeight > 0) this.style.minHeight = `${staticHeight}px`;
  }

  #initObservers() {
    this.formObserver = new IntersectionObserver(([entry]) => {
      this.formInView = entry.isIntersecting || entry.boundingClientRect.top >= 0;
      this.#updateDisplay();
    });
    this.formObserver.observe(this.form);
    if (!this.footer) return;
    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });
    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    const shouldShow = !this.formInView && !this.footerInView;
    const isActive = this.dataset.active === 'true';
    if (shouldShow) {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      delete this.dataset.closing;
      this.dataset.active = 'true';
      return;
    }
    if (!isActive) return;

    const finishClosing = () => {
      delete this.dataset.active;
      delete this.dataset.closing;
      this.#reserveStaticHeight();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClosing();
      return;
    }
    this.dataset.closing = 'true';
    this.content.addEventListener('animationend', finishClosing, { once: true });
    this.closeTimer = setTimeout(finishClosing, 350);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
